import React, { FunctionComponent, useEffect, useReducer } from 'react';
import { Button, EnergyArrow, Rating } from 'rs-emd-ui-atoms';
import { getLabel } from '../../../helpers/html.utils';
import { DocumentType } from '../../../models/common/document-item.model';
import { Action, EnergyLabelProductInfoActionType, EnergyLabelProductInfoProps, State } from './energy-label-product-info-component.model';
import styles from './energy-label-product-info-component.module.scss';

export const EnergyLabelProductInfo: FunctionComponent<EnergyLabelProductInfoProps> = (props: EnergyLabelProductInfoProps) => {
  const [state, dispatch] = useReducer(reducer, {
    euElrProductInformationSheetUrl: props.euElrProductInformationSheetUrl,
    energyProductInfoSheetNotFound: false,
    isEnergyProductInfoSheetBtnDisabled: false,
  });

  useEffect(() => {
    dispatch({
      type: EnergyLabelProductInfoActionType.SetEuElrProductInformationSheet,
      url: props.euElrProductInformationSheetUrl,
    });
  }, [props.euElrProductInformationSheetUrl]);

  return (
    <div className={`${styles['energy-container']} ${props.className ?? ''}`}>
      <EnergyArrow
        rating={props.energyArea.energyLabel.rating as Rating}
        src={props.energyArea.energyLabel.imgUrl ?? undefined}
        ratingLetterFontSize={props.ratingLetterFontSize ?? 18}
        modalShows2ImagesIn1={props.energyArea.energyLabel.isShowingTwoImagesInOne as boolean}
        onModalToggleCallback={props.onModalToggleCallback}
      />
      <Button
        href={state.euElrProductInformationSheetUrl}
        isExternalLink={true}
        target={'__blank'}
        buttonType='link'
        className={styles['energy-link']}
        icon={
          // if waiting for document query to complete
          state.isUnavailableEnergyProductInfoSheetBtnClicked ? 'circular-loader' : undefined
        }
        iconPosition='right'
        onClick={onClickEnergyProductInfoSheet}
        disabled={state.isEnergyProductInfoSheetBtnDisabled}
        text={getLabel(
          props.labels,
          state.energyProductInfoSheetNotFound ? 'energy_product_info_sheet_not_found' : 'energy_product_info_sheet'
        )}
      />
    </div>
  );

  function reducer(state: State, action: Action): State {
    switch (action.type) {
      case EnergyLabelProductInfoActionType.SetEuElrProductInformationSheet: {
        const isEnergyProductInfoSheetBtnNotFound =
          state.isUnavailableEnergyProductInfoSheetBtnClicked === true && action.url === undefined;

        return {
          ...state,
          euElrProductInformationSheetUrl: action.url,
          energyProductInfoSheetNotFound: isEnergyProductInfoSheetBtnNotFound,
          isEnergyProductInfoSheetBtnDisabled: isEnergyProductInfoSheetBtnNotFound,
          isUnavailableEnergyProductInfoSheetBtnClicked: false,
        };
      }
      case EnergyLabelProductInfoActionType.SetIsUnavailableEnergyProductInfoSheetBtnClicked: {
        return {
          ...state,
          isUnavailableEnergyProductInfoSheetBtnClicked: true,
          isEnergyProductInfoSheetBtnDisabled: true,
        };
      }
    }
  }

  function onClickEnergyProductInfoSheet() {
    // on first click of btn, if no product info sheet available yet, request documents query
    if (state.euElrProductInformationSheetUrl === undefined && !state.isUnavailableEnergyProductInfoSheetBtnClicked) {
      dispatch({
        type: EnergyLabelProductInfoActionType.SetIsUnavailableEnergyProductInfoSheetBtnClicked,
      });

      props.onUnavailableEnergyProductInfoSheetBtnClick && props.onUnavailableEnergyProductInfoSheetBtnClick();

      props.productService?.getDataSheets({ stockCode: props.stockCode, documentsType: '1' }).then((res) => {
        const euElrProductInformationSheetUrl = res.dataSheets?.find((d) => d.documentType === DocumentType.ElrProductInformationSheet);

        dispatch({
          type: EnergyLabelProductInfoActionType.SetEuElrProductInformationSheet,
          url: euElrProductInformationSheetUrl?.url,
        });

        if (euElrProductInformationSheetUrl?.url && euElrProductInformationSheetUrl?.url.length > 0) {
          //open new window
          window.open(euElrProductInformationSheetUrl.url, '_blank', 'noopener'); // 'noopener' prevents the opening page to gain any kind of access to the original page
        }
      });
    }
  }
};
